'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dist = {exports: {}};

exports.dist = dist;
